import APIClient from './index';
import _ from 'lodash';

export const createRegistrationCode = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/RegistrationCodes`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateRegistrationCode = (RegistrationCode, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/RegistrationCodes/${RegistrationCode.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getRegistrationCodes = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/RegistrationCodes?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getCountryBlockBypassCodes = () => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/RegistrationCodes/country_block_bypass`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const addCountryBlockBypassCode = code => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/RegistrationCodes/country_block_bypass`, { code })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const removeCountryBlockBypassCode = id => {
  return new Promise((resolve, reject) => {
    APIClient.delete(`/RegistrationCodes/country_block_bypass/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

/**
 * @param {Object} params
 * @param {string} [params.query] - search query
 * @param {number} [params.limit] - number of results to return
 * @param {number} [params.offset] - number of results to skip
 */
export const getBrandRegistrationCodes = params => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/BrandRegistrationCodes?${new URLSearchParams(params).toString()}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const createBrandRegistrationCode = data => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/BrandRegistrationCodes`, data)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const updateBrandRegistrationCode = (brandRegistrationCode, updates) => {
  return new Promise((resolve, reject) => {
    APIClient.put(`/BrandRegistrationCodes/${brandRegistrationCode.id}`, updates)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
